import { render, staticRenderFns } from "./EventRegistrationInfo.vue?vue&type=template&id=11767842&"
import script from "./EventRegistrationInfo.vue?vue&type=script&lang=js&"
export * from "./EventRegistrationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports